const SAME_ORIGIN_HOSTS = new Set([
  'ucarmotorsistem.com',
  'www.ucarmotorsistem.com'
]);

const normalizeUrl = (url) => (url || '').replace(/^http:/, 'https:').replace(/\/$/, '');

export const getAppBaseUrl = () => {
  const envUrl = normalizeUrl(process.env.REACT_APP_BACKEND_URL);

  if (typeof window !== 'undefined' && SAME_ORIGIN_HOSTS.has(window.location.hostname)) {
    return normalizeUrl(window.location.origin);
  }

  return envUrl;
};

export const getApiBaseUrl = () => `${getAppBaseUrl()}/api`;

export const getBrandingAssetUrl = (assetKey) => `${getApiBaseUrl()}/branding/assets/${assetKey}`;